import React, { useState } from 'react';
import { Box, Button, FormControl, FormLabel, Input, VStack, useToast } from '@chakra-ui/react';

interface CandidatureFormProps {
    onSubmit: (cvFile: File) => void;
}

/**
 * Formulaire pour déposer une candidature (PDF uniquement)
 */
const CandidatureForm: React.FC<CandidatureFormProps> = ({ onSubmit }) => {
    const [cv, setCv] = useState<File | null>(null);
    const toast = useToast();

    const handleSubmit = (e: React.FormEvent) => {
        e.preventDefault();
        if (!cv) {
            toast({
                title: "Veuillez ajouter un CV au format PDF.",
                status: "error",
                duration: 5000,
                isClosable: true,
            });
            return;
        }
        console.log("CV name:", cv.name);
        console.log("CV size:", cv.size);
        console.log("CV type:", cv.type);
        onSubmit(cv);
    };

    return (
        <Box as="form" onSubmit={handleSubmit} p={4} borderWidth="1px" borderRadius="md">
            <VStack spacing={4} align="stretch">
                <FormControl isRequired>
                    <FormLabel>Déposer votre CV (PDF uniquement)</FormLabel>
                    <Input
                        type="file"
                        accept="application/pdf"
                        onChange={(e) => setCv(e.target.files?.[0] || null)}
                    />
                </FormControl>
                <Button
                    colorScheme="teal"
                    type="submit"
                    isDisabled={!cv}
                >
                    Postuler
                </Button>
            </VStack>
        </Box>
    );
};

export default CandidatureForm;
